// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1xnq3","FooterButton":"Footer_FooterButton__3zVCL","ContactUs":"Footer_ContactUs__3qdaF"};